import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

// Restrições administrativas do cliente — mesma base de Customer usada por
// client.service.js. GET /administration/restrictions alimenta o select
// "Tipo de Restrição" da aba Dados Pessoais (issue #490).
const basePath = `${API_URLS.CUSTOMERS}/administration`;

async function fetchRestrictions() {
  try {
    let response = await api.get(`${basePath}/restrictions`);
    let treated = errorHandling.handleResponse(
      response,
      "administrationService.fetchRestrictions"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "administrationService.fetchRestrictions");
    return null;
  }
}

export const administrationService = {
  fetchRestrictions,
};
